export enum RepurchasedContractType {
  default = 'default',
  external = 'external',
}
